/**
 * Section : Collection principale — FOG Theme
 * Accordeon FAQ
 */

(function () {
  'use strict';

  function initFaqAccordion() {
    var questions = document.querySelectorAll('.main-collection__faq-question');

    if (!questions.length) return;

    questions.forEach(function (button) {
      button.addEventListener('click', function () {
        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        var answerId = button.getAttribute('aria-controls');
        var answer = document.getElementById(answerId);
        var item = button.closest('.main-collection__faq-item');

        if (!answer) return;

        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          answer.hidden = true;
          item.classList.remove('is-open');
        } else {
          button.setAttribute('aria-expanded', 'true');
          answer.hidden = false;
          item.classList.add('is-open');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();

/**
 * Gammes en piste horizontale (mobile) : la gamme active est amenee au centre
 * de la piste au chargement. scrollLeft et non scrollIntoView, qui ferait
 * aussi defiler la page verticalement.
 */
(function () {
  'use strict';

  function centerActiveRange() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-collection-ranges]'), function (nav) {
      if (nav.scrollWidth <= nav.clientWidth) return;
      var active = nav.querySelector('[aria-current="page"]');
      if (!active) return;
      nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', centerActiveRange);
  } else {
    centerActiveRange();
  }
})();

/**
 * Recherche par nom dans tout le catalogue
 *
 * Remplace la grille en place par les produits trouves dans TOUT le catalogue,
 * quelle que soit la page (gamme ou /collections) : l'index (titre, handle,
 * URL et carte rendue de chaque produit) vient de sections/collection-search-index.liquid,
 * demande sur /collections/all par l'API Section Rendering au premier focus du champ.
 *
 * Tolerance, du plus strict au plus large :
 *   1. casse, accents, espaces, tirets et points ignores (« blackseries »,
 *      « black-series », « ecs1 », « fog » pour F.O.G) ;
 *   2. mots dans n'importe quel ordre (« series black ») ;
 *   3. sigles (« bs 320 » pour Black Series 320W) ;
 *   4. fautes de frappe (« blak serie », « balck ») : distance d'edition sur la
 *      meilleure sous-chaine du nom, seulement quand 1 a 3 ne trouvent rien,
 *      pour ne jamais melanger un « X-CLONE PRO 10 » aux resultats exacts de
 *      « x clone pro 30 ».
 *
 * Les cartes inserees declenchent `fog:cards-added` sur document : b2b-spark-cards.js
 * y pose le tarif pro comme sur la grille chargee avec la page.
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 120;

  /* ---------- Normalisation ---------- */

  function fold(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  function words(s) {
    return fold(s).split(/[^a-z0-9]+/).filter(Boolean);
  }

  function compact(s) {
    return fold(s).replace(/[^a-z0-9]+/g, '');
  }

  /* Fautes tolerees selon la longueur de ce qui est tape : aucune sous 4
     caracteres (sinon « v6 » trouverait tout), une jusqu'a 6, deux au-dela. */
  function tolerance(len) {
    return len <= 3 ? 0 : len <= 6 ? 1 : 2;
  }

  /* Distance d'edition minimale entre p et n'importe quelle sous-chaine de t
     (algorithme de Sellers), transposition de deux lettres voisines comptee
     comme une seule faute (« balck » = « black » a 1). */
  function fuzzyDistance(p, t) {
    var m = p.length;
    if (!m) return 0;
    var prev2 = null;
    var prev = [];
    var cur;
    var i;
    var j;
    for (i = 0; i <= m; i++) prev[i] = i;
    var best = m;
    for (j = 0; j < t.length; j++) {
      var c = t.charAt(j);
      cur = [0];
      for (i = 1; i <= m; i++) {
        var v = Math.min(prev[i] + 1, cur[i - 1] + 1, prev[i - 1] + (p.charAt(i - 1) === c ? 0 : 1));
        if (prev2 && i > 1 && p.charAt(i - 1) === t.charAt(j - 1) && p.charAt(i - 2) === c) {
          v = Math.min(v, prev2[i - 2] + 1);
        }
        cur[i] = v;
      }
      if (cur[m] < best) best = cur[m];
      prev2 = prev;
      prev = cur;
    }
    return best;
  }

  /* ---------- Index ---------- */

  function buildItem(el, index) {
    var title = el.getAttribute('data-title') || '';
    var tw = words(title);
    var starts = [];
    var pos = 0;
    tw.forEach(function (w) {
      starts.push(pos);
      pos += w.length;
    });
    return {
      el: el,
      index: index,
      title: title,
      url: el.getAttribute('data-url') || '',
      T: tw.join(''),
      starts: starts,
      H: compact(el.getAttribute('data-handle')),
      /* Sigle : initiale de chaque mot, mots chiffres gardes entiers.
         « 1x BARRE LED BLACK SERIES 320W » donne « 1xblbs320w ». */
      A: tw.map(function (w) { return /\d/.test(w) ? w : w.charAt(0); }).join(''),
      node: null
    };
  }

  function strictScore(it, qc, qw) {
    var T = it.T;
    if (T === qc) return 1000;
    var at = T.indexOf(qc);
    if (at === 0) return 900 - T.length * 0.1;
    while (at > 0) {
      if (it.starts.indexOf(at) !== -1) return 800 - T.length * 0.1;
      at = T.indexOf(qc, at + 1);
    }
    /* Une seule lettre : uniquement en debut de mot, sinon tout correspond. */
    if (qc.length < 2) return 0;
    if (T.indexOf(qc) !== -1) return 700 - T.length * 0.1;
    if (it.H.indexOf(qc) !== -1) return 600;
    /* Plusieurs mots, ordre libre : tous dans le nom d'abord, puis chacun dans le
       nom, le handle ou le sigle (« transfo bs 400 »). */
    if (qw.length > 1) {
      if (qw.every(function (w) { return T.indexOf(w) !== -1; })) return 550 - T.length * 0.1;
      if (qw.every(function (w) { return T.indexOf(w) !== -1 || it.H.indexOf(w) !== -1 || it.A.indexOf(w) !== -1; })) {
        return 480 - T.length * 0.1;
      }
    }
    if (it.A.indexOf(qc) !== -1) return 450 - T.length * 0.1;
    return 0;
  }

  function fuzzyScore(it, qc, qw) {
    var tol = tolerance(qc.length);
    if (tol > 0) {
      var d = fuzzyDistance(qc, it.T);
      if (d <= tol) return 300 - d * 50 - it.T.length * 0.1;
    }
    /* Plusieurs mots : chacun doit se retrouver, avec sa propre tolerance. */
    if (qw.length > 1) {
      var total = 0;
      for (var k = 0; k < qw.length; k++) {
        var dw = fuzzyDistance(qw[k], it.T);
        if (dw > tolerance(qw[k].length)) return 0;
        total += dw;
      }
      return 200 - total * 30 - it.T.length * 0.1;
    }
    return 0;
  }

  function search(items, q) {
    var qc = compact(q);
    var qw = words(q);
    var hits = [];
    items.forEach(function (it) {
      var s = strictScore(it, qc, qw);
      if (s > 0) hits.push({ it: it, s: s });
    });
    if (!hits.length) {
      items.forEach(function (it) {
        var s = fuzzyScore(it, qc, qw);
        if (s > 0) hits.push({ it: it, s: s });
      });
    }
    hits.sort(function (a, b) { return b.s - a.s || a.it.index - b.it.index; });
    return hits.map(function (h) { return h.it; });
  }

  /* Aucun resultat : les noms les plus proches. Un produit est propose si
     l'ensemble tape en est a moins d'un tiers d'ecart (au-dela, « lampe »
     proposait AMP-2), ou si au moins un mot de 4 lettres ou plus s'y retrouve
     a la tolerance pres (« proguad mni xyz » propose les ProGuard). Classement :
     nombre de mots retrouves, puis ecart. */
  function nearest(items, q, max) {
    var qc = compact(q);
    var qw = words(q).filter(function (w) { return w.length >= 4; });
    var limit = Math.max(1, Math.floor(qc.length / 3));
    return items
      .map(function (it) {
        var d = fuzzyDistance(qc, it.T);
        var hits = 0;
        qw.forEach(function (w) {
          if (fuzzyDistance(w, it.T) <= tolerance(w.length)) hits++;
        });
        return { it: it, d: d, hits: hits };
      })
      .filter(function (r) { return r.d <= limit || r.hits > 0; })
      .sort(function (a, b) { return b.hits - a.hits || a.d - b.d || a.it.index - b.it.index; })
      .slice(0, max)
      .map(function (r) { return r.it; });
  }

  /* ---------- Interface ---------- */

  function init(form) {
    /* Portee : la section qui porte data-search-scope (main-collection ou
       main-list-collections), voir snippets/collection-search-form.liquid. */
    var section = form.closest('[data-search-scope]');
    if (!section) return;
    var input = form.querySelector('[data-search-input]');
    var page = section.querySelector('[data-collection-page]');
    var results = section.querySelector('[data-search-results]');
    var grid = section.querySelector('[data-search-grid]');
    var empty = section.querySelector('[data-search-empty]');
    var emptyTitle = section.querySelector('[data-search-empty-title]');
    var suggest = section.querySelector('[data-search-suggest]');
    var suggestList = section.querySelector('[data-search-suggest-list]');
    var count = section.querySelector('[data-collection-count]');
    var clears = section.querySelectorAll('[data-search-clear]');
    var fieldClear = form.querySelector('[data-search-clear]');
    if (!input || !page || !results || !grid || !count) return;

    var defaultCount = count.textContent;
    var items = null;
    var loading = null;
    var failed = false;
    var timer = null;

    function msg(name, n, q) {
      /* Attribut rendu par | t sans | escape : le navigateur decode deja
         « l&#39;ajout » en lisant l'attribut, pas de second decodage. */
      var tpl = form.getAttribute('data-msg-' + name) || '';
      /* Remplacement par fonction : un « $& » tape ne doit pas etre interprete.
         Le resultat part toujours en textContent. */
      return tpl
        .replace('__COUNT__', function () { return String(n); })
        .replace('__QUERY__', function () { return q; });
    }

    function load() {
      if (loading) return loading;
      loading = fetch(form.getAttribute('data-index-url'), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var root = doc.querySelector('[data-fog-search-index]');
          if (!root) throw new Error('index absent de la reponse');
          items = Array.prototype.map.call(root.querySelectorAll('[data-fog-search-item]'), buildItem);
          var total = parseInt(root.getAttribute('data-total'), 10);
          if (total > items.length) {
            console.warn('[FOG recherche] index partiel :', items.length, 'produits sur', total);
          }
          return items;
        })
        .catch(function (err) {
          failed = true;
          console.warn('[FOG recherche] index indisponible, repli sur la recherche du site :', err);
          throw err;
        });
      return loading;
    }

    function prefetch() {
      load().catch(function () {});
    }

    /* La carte d'un produit est creee une fois puis reutilisee : son widget
       SparkLayer (session pro) ne s'hydrate qu'une fois. */
    function cardFor(it) {
      if (!it.node) {
        var src = it.el.querySelector('.product-card') || it.el.firstElementChild;
        it.node = document.importNode(src, true);
      }
      return it.node;
    }

    function syncUrl(q) {
      try {
        var url = new URL(window.location.href);
        if (q) url.searchParams.set('q', q);
        else url.searchParams.delete('q');
        history.replaceState(history.state, '', url);
      } catch (e) {
        /* Safari limite replaceState (100 appels / 30 s) : l'URL n'est qu'un confort. */
      }
    }

    function reset() {
      results.hidden = true;
      page.hidden = false;
      grid.replaceChildren();
      count.textContent = defaultCount;
    }

    function renderSuggestions(q) {
      var list = nearest(items, q, 3);
      suggestList.replaceChildren();
      list.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = it.url;
        a.className = 'main-collection__suggest-link';
        a.textContent = it.title;
        li.appendChild(a);
        suggestList.appendChild(li);
      });
      suggest.hidden = list.length === 0;
    }

    function render(list, q) {
      page.hidden = true;
      results.hidden = false;
      /* Francais : 0 et 1 prennent le singulier. */
      count.textContent = msg(list.length < 2 ? 'results-one' : 'results-other', list.length, q);
      if (list.length) {
        empty.hidden = true;
        grid.hidden = false;
        grid.replaceChildren.apply(grid, list.map(cardFor));
        document.dispatchEvent(new CustomEvent('fog:cards-added', { detail: { root: grid } }));
      } else {
        grid.hidden = true;
        grid.replaceChildren();
        emptyTitle.textContent = msg('none', 0, q);
        renderSuggestions(q);
        empty.hidden = false;
      }
    }

    function run() {
      var q = input.value.trim();
      if (fieldClear) fieldClear.hidden = input.value.length === 0;
      syncUrl(q);
      if (!compact(q)) {
        reset();
        return;
      }
      if (failed) {
        count.textContent = msg('unavailable');
        return;
      }
      if (!items) {
        count.textContent = msg('loading');
        load().then(
          function () { if (input.value.trim() === q) run(); },
          function () { if (input.value.trim() === q) count.textContent = msg('unavailable'); }
        );
        return;
      }
      render(search(items, q), q);
    }

    function clear() {
      input.value = '';
      clearTimeout(timer);
      run();
      input.focus();
    }

    input.addEventListener('focus', prefetch);
    form.addEventListener('pointerenter', prefetch);

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, DEBOUNCE_MS);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (input.value) {
        e.preventDefault();
        clear();
      } else {
        input.blur();
      }
    });

    /* Entree : resultat immediat sur place. Si l'index n'a pas pu etre charge,
       le formulaire part vers la recherche native du site (/search). */
    form.addEventListener('submit', function (e) {
      if (failed) return;
      e.preventDefault();
      clearTimeout(timer);
      run();
      if (window.matchMedia('(pointer: coarse)').matches) input.blur();
    });

    Array.prototype.forEach.call(clears, function (btn) {
      btn.addEventListener('click', clear);
    });

    /* Lien partage ou retour arriere : ?q= relance la recherche. */
    var initial = new URLSearchParams(window.location.search).get('q');
    if (initial) {
      input.value = initial;
      run();
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-collection-search]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
